import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Card = ({ fields }) => {
  var bgColor = fields.background_color || '#ffffff'
  return (
    <li
      className={`component-card relative flex flex-1 flex-col overflow-hidden rounded-md p-4 shadow ${
        fields.button_link?.url && 'translate ease group transform duration-300 hover:-translate-y-2 hover:shadow-lg'
      }`}
      style={{ backgroundColor: `${bgColor}` }}>
      {fields.image?.gatsbyImageData && (
        <div className='relative mb-4 flex-shrink-0'>
          <GatsbyImage
            // sizes='(min-width: 768px) calc((100vw - 10rem)/3),(min-width: 1152) calc((1152px - 10rem)/3), calc(100vw - 4rem)'
            image={fields.image.gatsbyImageData}
            alt={fields.image.alt || ''}
          />
          {fields.image.copyright && <span className='absolute bottom-0 right-0 m-2 rounded-sm bg-black px-2 py-1 text-xs text-white opacity-50'>{fields.image.copyright}</span>}
        </div>
      )}
      <div className='mb-4 flex flex-grow flex-col space-y-3'>
        <div className='flex flex-row items-center'>
          {fields.icon && <img width='48px' height='48px' src={`../images/icon-${fields.icon.toLowerCase()}.svg`} alt={fields.icon} className='mr-2 h-10 w-10 md:h-12 md:w-12' loading='lazy' />}
          {fields.title.richText && (
            <div className='font-serif text-lg text-orange-500 md:text-2xl'>
              <PrismicRichText field={fields.title.richText} />
            </div>
          )}
        </div>
        {fields.text.richText && (
          <div className='prose prose-blue'>
            <PrismicRichText field={fields.text.richText} />
          </div>
        )}
      </div>
      {fields.button_link && (
        <div className='z-10 mt-auto flex justify-center text-center'>
          <PrismicLink className={`${fields.button_text ? 'button' : 'link'}`} field={fields.button_link}>
            {fields.button_text ? fields.button_text : <span className='sr-only'>View</span>}
            <span className='absolute inset-0 cursor-pointer' aria-hidden='true'></span>
          </PrismicLink>
        </div>
      )}
    </li>
  )
}

export default Card
